import Vue from 'vue'
import VuePlotly from '@/components/VuePlotly/index-plotly.vue'

// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Plot', VuePlotly)